<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <!-- -->
        <div class="card-header">
        </div>
        <!-- -->
        <div class="card-body tab2-card">
          <form [formGroup]="validationForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Date identificare PJ</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Denumire<span>*</span></label>
                <input class="form-control" type="text" formControlName="name" />
                <div *ngIf="validationForm.controls['name'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Nume companie obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Forma juridica<span>*</span></label>
                <select class="form-control digits" formControlName="legalForm">
                  <option>Societate pe acţiuni (SA)</option>
                  <option>Societate cu răspundere limitată (SRL)</option>
                  <option>Persoană fizică autorizată (PFA)</option>
                  <option>Regie autonoma (RA)</option>
                  <option>Institutie publica</option>
                  <option>Societate în nume colectiv</option>
                  <option>Societate în comandită simplă</option>
                  <option>Societate în comandită pe acţiuni</option>
                  <option>Întreprindere individuală (ÎI)</option>
                  <option>Întreprindere familială (ÎF)</option>
                  <option>Altele</option>
                </select>
                <div
                  *ngIf="validationForm.controls['legalForm'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Forma juridica obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CUI<span>*</span></label>
                <input class="form-control" type="text" formControlName="cui" />
                <div *ngIf="validationForm.controls['cui'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  CUI sau invalid
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Nr. inregistrare la ONRC<span>*</span></label>
                <input class="form-control" type="text" formControlName="onrcRegistrationNumber" />
                <div
                  *ngIf="validationForm.controls['onrcRegistrationNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numar inregistrare ONRC obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Telefon</label>
                <input class="form-control" type="text" formControlName="phoneNumber" />
                <div
                  *ngIf="validationForm.controls['phoneNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numarul de telefon contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Mobil</label>
                <input class="form-control" type="text" formControlName="mobileNumber" />
                <div
                  *ngIf="validationForm.controls['mobileNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numarul de telefon mobil contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Fax</label>
                <input class="form-control" type="text" formControlName="fax" />
                <div *ngIf="validationForm.controls['fax'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numarul de fax contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Email</label>
                <input class="form-control" type="text" formControlName="email" />
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4> Date licenta</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Numar licenta gaz</label>
                <input class="form-control" type="text" formControlName="licenseGas" />
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Numar licenta electricitate</label>
                <input class="form-control" type="text" formControlName="licenseElectricity" />
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4> Adresa sediu social</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div
                  *ngIf="validationForm.controls['county'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Judetul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div *ngIf="validationForm.controls['city'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Orasul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName" />
                <div
                  *ngIf="validationForm.controls['streetName'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numele strazii sediului social este obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber" />
                <div
                  *ngIf="validationForm.controls['streetNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numarul strazii sediului social este obligatorie
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode" />
                <div
                  *ngIf="validationForm.controls['postalCode'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Codul postal al sediului social este obligatoriu.
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <span class="bold"> Adresa de corespondență</span>
              </div>
              <div class="col-xl-3 col-md-3">
                <label class="d-block" for="chk-ani">
                  <input class="checkbox_animated" id="chk-ani" type="checkbox" formControlName="sameAddress">
                  Aceeasi cu adresa sediului social
                </label>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCounty">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div
                  *ngIf="validationForm.controls['correspondenceCounty'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCity">
                  <option *ngFor="let city of citiesCorrespondence" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div
                  *ngIf="validationForm.controls['correspondenceCity'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetName" />
                <div
                  *ngIf="validationForm.controls['correspondenceStreetName'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numele strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetNumber" />
                <div
                  *ngIf="validationForm.controls['correspondenceStreetNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Numarul strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="correspondenceBlock" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="correspondenceFloor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="correspondenceApartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondencePostalCode" />
                <div
                  *ngIf="validationForm.controls['correspondenceStreetNumber'].errors &&  (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  Codul postal al adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Date identificare persoana</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Nume</label>
                <input class="form-control" type="text" formControlName="firstName" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Prenume</label>
                <input class="form-control" type="text" formControlName="lastName" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CNP</label>
                <input class="form-control" type="text" formControlName="cnp" />
                <div *ngIf="validationForm.controls['cnp'].errors && (validationForm.dirty || validationForm.touched)"
                  class="text text-danger">
                  CNP este obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Documente justificative</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngFor="let document of validationDetails?.documents">
              <div class="col-xl-8 col-md-8">
                <span>{{document.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="document.fileByteSize">{{document.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="document.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(document)">Descarca</a>
              </div>
            </div>
            <br>
            <div class="form-group row">
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Validare cont si alocare rol</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl col-md">
                <label class="d-block" for="chk-val">
                  <input class="checkbox_animated" type="checkbox" id="chk-val" (click)="toggleValidated()"
                    formControlName="validated" [checked]="isValidated">
                  Validare cont si Alocare rol Administrare conturi
                </label>
              </div>
            </div>
            <br>
            <ng-container *ngIf="!isValidated">
              <div class="form-group row">
                <div class="col-xl-2 col-md-2">
                  <label>Motivul pentru care nu validati</label>
                </div>
                <div class="col-xl-5 col-md-5">
                  <textarea class="input" rows="4" formControlName="invalidationReason"></textarea>
                </div>
              </div>
              <br>
            </ng-container>
            <div class="form-group row mb-0 pull-right">
              <div class="col-xl-auto col-md-auto">
                <button type="button" [routerLink]="'/anre/task-uri'" class="btn btn-light button-margin">Renunta
                </button>
                <button [disabled]="!isValidated && !validationForm.get('invalidationReason').value" *ngIf="editable"
                  type="button" class="btn btn-primary mr-1 button-margin" (click)="saveValidationDetails()">
                  Transmite
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Container-fluid Ends-->